import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./modal.css";
import warningerrorImage from "../assets/icon_warning_error.svg";
import successImage from "../assets/icon_success.svg";

function SubmitModal({
  setopenSubmitModal,
  openSubmitModal,
  modalState,
  onWarningSubmit,
  handleClose,
  setResponse,
  response,
}) {
  const handleClosemodal = () => {
    // if (modalState !== "Warning")
    // window.location.href = "https://www.engagedigital.ai";
    setopenSubmitModal(false);
    setResponse("");
  };
  return (
    <>
      <Modal show={openSubmitModal} backdrop="static" keyboard={false}>
        <Modal.Body>
          {modalState === "Error" && (
            <>
              <div className="imageStyle">
                <img src={warningerrorImage} alt="" className="image" />
              </div>
              <p className="responsetextStyle">
                {response?response:`Something went wrong Please try again after
                sometime.`}
              </p>
            </>
          )}
          {modalState === "Warning" && (
            <>
              <div className="imageStyle">
                <img src={warningerrorImage} alt="" className="image" />
              </div>
              <p className="descriptionText">
                There are one or more warnings found in the details provided.
              </p>
              <p style={{ textAlign: "center" }} className="descriptionText">
                Do you want to continue?
              </p>
            </>
          )}
          {modalState === "Success" && (
            <>
              <div className="imageStyle">
                <img src={successImage} alt="" className="image" />
              </div>
              <p className="responsetextStyle">{response}</p>
              <p className="descriptionText">
                You will shortly receive a confirmation email with details on
                next steps. Please wait for the email and do not submit
                duplicate request again.{" "}
              </p>
              <p style={{ textAlign: "center" }} className="descriptionText">
                Also, make sure to check your spam folder in case you don't find
                them in your inbox.
              </p>
            </>
          )}
          {(modalState === "Success" ||
            modalState === "Error") && (
              <div className="buttonDiv">
                <Button
                  variant="secondary"
                  onClick={() => handleClose()}
                  className="okbuttonStyle"
                >
                  OK
                </Button>
              </div>
            )}
          {modalState ===
            "Warning"&&(
              <div className="buttonDiv">
                <Button
                  className="nobuttonStyle"
                  variant="primary"
                  onClick={() => {
                    handleClosemodal();
                  }}
                >
                  No
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => onWarningSubmit()}
                  className="buttonStyle"
                >
                  Yes
                </Button>
              </div>
            )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SubmitModal;
